import { combineReducers, createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import productReducer from './Slices/productSlice'; // Import your product reducer

// Import other reducers
import {
  currentUserReducer,
  otpReducer,
  phoneNumberReducer,
  userReducer,
} from './reducers/userReducer';
import { cartReducer } from './reducers/cartReducer';
import { addressReducer } from './reducers/addressReducers';
import { wishlistReducer } from './reducers/wishlistReducers';
import { categoryReducer } from './reducers/categoryReducers';
import { collectionReducer } from './reducers/collectionReducer';
import { fbAuthReducer } from './reducers/fbAuthReducers';
import { saveForLaterReducer } from './reducers/saveForLaterReducers';
import {
  individualOrderReducer,
  orderReducer,
  userOrdersReducer,
} from './reducers/orderReducers';
import { customNavContainerReducer } from './reducers/customNavContainerReducers';
import { recentlyViewedReducer } from './reducers/recentlyViewedReducers';

// Combine all reducers
const rootReducer = combineReducers({
  products: productReducer, // This should handle both products and searchedProducts
  address: addressReducer,
  categories: categoryReducer,
  collections: collectionReducer,
  user: userReducer,
  currentUser: currentUserReducer,
  otp: otpReducer,
  cart: cartReducer,
  saveForLater: saveForLaterReducer,
  wishlist: wishlistReducer,
  order: orderReducer,
  userAllOrders: userOrdersReducer,
  orderDetails: individualOrderReducer,
  fbAuth: fbAuthReducer,
  customNavContainer: customNavContainerReducer,
  recentlyViewed: recentlyViewedReducer,
});

// Retrieve persisted state from localStorage
const persistedState = {
  cart: {
    cartItems: {},
    priceDetails: {},
    totalItems: {},
  },
  user: {
    isLoggedIn: localStorage.getItem('isLoggedIn') === 'true', // Retrieve isLoggedIn state from localStorage
  },
};

// Create the Redux store
const store = createStore(
  rootReducer,
  persistedState,
  composeWithDevTools(applyMiddleware(thunk))
);

// Subscribe to store changes
store.subscribe(() => {
  const state = store.getState();
  localStorage.setItem('isLoggedIn', state.user.isLoggedIn ? 'true' : 'false'); // Store isLoggedIn state in localStorage
});

export default store;
